<template>
<div>
  <v-dialog title="공동인증서" v-model="certificateDialog" persistent max-width="460px" width="460px" class="noShadow">
    <div id="wrap">
      <form id="pubCertForm" ref="pubCertForm" target="pubCertFrame" :action="certURL + subURL">
        <input type = "hidden" name="hash" :value="hash"/>
        <input type = "hidden"  name="verifyType" :value="verifyType"/>
        <input type = "hidden"  name="verifyData" :value="verifyData"/>
      </form>
      <iframe
        width="100%"
        name="pubCertFrame"
        height="650px"
        style="border:none">
      </iframe>
    </div>
  </v-dialog>
</div>
</template>
<script>
export default {
  name: 'pubCert',
  components: {
  },
  filters: {
  },
  props:{
    certRegno: String,
    hash: String
  },
  data () {
    return {
      // 상세 다이얼로그
      certificateDialog: false,
      certURL: process.env.VUE_APP_URL_AUTH,
      subURL: '/pubCertificate/auth',
      sign: null,
      vid: null,
      // 인증서 타입: 개인: 1 / 기업 2
      verifyType: '2',
      // 인증서 신원검증데이터: 개인: 본인이름 / 기업: 사업자번호
      verifyData:''
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    open() {
      this.$forceUpdate()
      this.certificateDialog = true
      this.verifyData = btoa(encodeURIComponent(this.certRegno))
      setTimeout(this.pubOpen, 1000);
    },
    close () {
      this.certificateDialog = false
    },
    pubOpen () {
      this.$nextTick(() => {
        window.addEventListener('message', this.pubCertResult, true)
        this.$refs.pubCertForm.submit()
      })
    },
    pubCertResult (result) {
      var data = result.data

      this.$nextTick(() => {
        this.certificateDialog = false
        if (data.errorCode === '0000') {
          this.$emit('childs-event', data.result.vid, data.result.message, data.result.sign, data.result.certPEM)
        }else{
          this.$emit('childs-event', data.result.vid, data.result.message, data.result.sign, data.result.certPEM)
        }
      })
    }
  }
}
</script>
